export default function toPercent(value: number, total?: number, decimalPrecision?: number) {
    const percent = total ? (value / total) * 100 : 0;
    if (decimalPrecision === undefined || isNaN(decimalPrecision)) {
        return percent;
    }
    return parseFloat(percent.toFixed(decimalPrecision));
}
